import { firstValueFrom, from, Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigService } from '@shared/services/core/config.service';

import { CacheService } from '../services';
import { CompanyFacilityService } from '@shared/facility-services/company.facility.service';
import { environment } from '@environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

	private companyFacilityService = inject(CompanyFacilityService);

	constructor(private cacheService: CacheService, private readonly env: ConfigService) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (request.url.indexOf(environment.rentalsApiEndPoint) > -1) {
			return this.companyFacilityService.companyId$.pipe(take(1)).pipe(
				switchMap(companyId => {
					let additionalHeaders = {};

					if (companyId) {
						additionalHeaders = {
							...additionalHeaders,
							'X-VQuip-Company-Id': `${companyId.toString()}`,
						};
					}

					request = request.clone({ setHeaders: additionalHeaders });

					return next.handle(request);
				})
			);
		}

		return from(
			Promise.all([
				this.cacheService.get('secure:accessToken'),
				this.cacheService.get('secure:idToken'),
			])
		).pipe(
			switchMap(resp => {
				const [accessToken, idToken] = resp;
				if (accessToken && idToken) {
					request = request.clone({
						setHeaders: {
							Authorization: `Bearer ${accessToken}`,
							idToken: `${idToken.toString()}`,
							'x-api-key': this.env.get('apiKey'),
						},
					});
				}

				return next.handle(request);
			})
		);
	}
}
